import React from 'react'
import { connect } from 'react-redux'
import store from 'store'
import _ from 'lodash'


const I18n = connect(
  store => ({
    i18n: store.i18n
  })
)(
  props => {
    const { caseType } = props

    if (_.isFunction(caseType))
      return <span data-key={props.translate}>{ caseType(_.get(props.i18n, `data[${props.translate}]`, props.translate)) }</span>

    return <span data-key={props.translate}>{ _.get(props.i18n, `data[${props.translate}]`, props.translate) }</span>
  }
)

const _t = (labelKey, placheholder=false, caseType=null, replace={}) => {
  if (placheholder) {
    const translations = store.getState().i18n
    let retTranslation = false

    if (_.isFunction(caseType))
      retTranslation = caseType(_.get(translations, `data[${labelKey}]`, labelKey))
    else
      retTranslation = _.get(translations, `data[${labelKey}]`, labelKey)

    if (replace !== {}) {
      retTranslation = _.reduce(
        replace,
        (red, e, key) => red.replace(`{${key}}`, e),
        retTranslation,
      )
    }

    return retTranslation

  }

  return <I18n translate={labelKey} caseType={caseType} />
}


const _tr = (labelKey, replace={}) => {
  return _t(labelKey, true, null, replace)
}

export {_t as default, _tr}
